import { render, staticRenderFns } from "./SentToReworkLog.vue?vue&type=template&id=1b95dc34"
import script from "./SentToReworkLog.vue?vue&type=script&lang=js"
export * from "./SentToReworkLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports